import apiClient from '../apiClient';
import { GET_EXCURSION_PRICE_EXPORT_DATA_URL } from '../apiUrl';

const getExportExcursionPriceApi = () => {
  return apiClient.get(GET_EXCURSION_PRICE_EXPORT_DATA_URL);
};

export default getExportExcursionPriceApi;
